import { signerApi, ApiError } from '@/api/index.js';

const DRIFT_LIMIT_MS = 5 * 60 * 1000; // 5 minutes

// Throws if clock drift vs. edge-signer server exceeds DRIFT_LIMIT_MS.
export async function checkClockDrift() {
  const before = Date.now();
  let serverTime: string;
  try {
    ({ server_time: serverTime } = await signerApi.ping());
  } catch (e) {
    const status = e instanceof ApiError ? e.status : 0;
    throw new Error(`Signer unreachable (${status})`);
  }
  const after = Date.now();
  const serverMs = new Date(serverTime).getTime();
  const clientMs = Math.round((before + after) / 2);
  const drift = Math.abs(clientMs - serverMs);
  if (drift > DRIFT_LIMIT_MS) {
    throw new Error(
      `Clock drift of ${Math.round(drift / 1000)}s detected. Check your device clock before signing.`,
    );
  }
}

// Module-scope: no closure over composable state
export async function verifyJws(jws) {
  return signerApi.verify(jws);
}
